module.exports = __webpack_public_path__ + "img/erel.df781b05.png";